<template>
    <div class="product-page mt-3">

        <div class="section">
            <div class="container">

                <div class="loading" v-if="loading">
                </div>

                <nav aria-label="breadcrumb" v-if="!loading && mainArtist">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">{{ $t('links.home') }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page" v-if="!loading">
                            {{mainArtist.artistnatuerlich}}
                        </li>
                    </ol>
                </nav>

                <div class="main main-raised main-product" style="margin: 0" v-if="!loading && mainArtist">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="title">{{mainArtist.artistnatuerlich}}</h2>
                        </div>
                    </div>

                    <dl class="row mt-3" v-if="hasAlsoknownas || hasRecordingswith">
                        <template v-if="hasAlsoknownas">
                            <dt class="col-sm-3 mt-1">{{ $t('artist.alternative_names') }}:</dt>
                            <dd class="col-sm-9 mt-1">
                                <template v-for="(anArtistid, index) in alsoknownas">
                                    <router-link v-if="anArtistid.artistid" :to="'/artist/' + encodeURIComponent(anArtistid.artistnatuerlich) + '/' + anArtistid.artistid">{{anArtistid.artistnatuerlich}}</router-link>
                                    <span v-else>{{anArtistid.artistnatuerlich}}</span>{{ ((index + 1) < alsoknownas.length) ? ', ' : ''}}
                                </template>
                            </dd>
                        </template>

                        <template v-if="hasRecordingswith">
                            <dt class="col-sm-3 mt-1">{{ $t('artist.records_with') }}:</dt>
                            <dd class="col-sm-9 mt-1">
                                <template v-for="(anArtistid, index) in recordingswith">
                                    <router-link v-if="anArtistid.artistid" :to="'/artist/' + encodeURIComponent(anArtistid.artistnatuerlich) + '/' + anArtistid.artistid">{{anArtistid.artistnatuerlich}}</router-link>
                                    <span v-else>{{anArtistid.artistnatuerlich}}</span>{{ ((index + 1) < recordingswith.length) ? ', ' : ''}}
                                </template>
                            </dd>
                        </template>

                    </dl>

                    <div class="row" v-if="!loading && discography.length > 0">
                        <div class="col-12 mt-3">
                            <div id="discography-container">
                                <h3 class="title mb-0">{{ $t('artist.discography') }}</h3>
                                <div class="row">
                                    <div class="col-12">

                                        <paginate ref="paginator" name="discographyPagination"
                                                  :list="discography"
                                                  :per="6"
                                                  tag="div"
                                                  class="row">
                                            <div is="list-product"
                                                 v-for="articlesArtistid in paginated('discographyPagination')"
                                                 :key="articlesArtistid.id"
                                                 :id="articlesArtistid.id"
                                                 :title="articlesArtistid.article.title"
                                                 :article="articlesArtistid.article"
                                            ></div>
                                        </paginate>

                                        <paginate-links for="discographyPagination"
                                                        :limit="2"
                                                        :show-step-links="true"
                                                        :classes="{
                                                                'ul': ['pagination', 'justify-content-center'],
                                                                'ul.paginate-links > li': 'page-item',
                                                                'ul.paginate-links > li > a': 'page-link',
                                                                'ul.paginate-links > li.active': 'active'
                                                            }"
                                                        :step-links="{
                                                                next: 'Next',
                                                                prev: 'Previous'
                                                            }"
                                                        @change="onPageChange"></paginate-links>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import ListProductComponent from './ListProductComponent.vue'
import DataService from '../../services/DataService'
import { logger } from '../../util/Logger'
import endsWith from 'lodash-es/endsWith'
import padStart from 'lodash-es/padStart'

export default {
  name: 'ArtistDetailComponent',
  components: {
    'list-product': ListProductComponent
  },
  data () {
    return {
      loading: true,
      mainArtist: null,
      alsoknownas: [],
      recordingswith: [],
      discography: [],
      paginate: ['discographyPagination'],
      recordsWith: {}
    }
  },
  computed: {
    hasRecordingswith: function () {
      return this.recordingswith.length > 0
    },
    hasAlsoknownas: function () {
      return this.alsoknownas.length > 0
    }
  },
  watch: {
    // call again the method if the route changes
    $route: 'getArtist'
  },
  methods: {
    getNormalizedArtistid (artistid) {
      if (artistid.length === 7 && endsWith(artistid, 'a')) {
        return artistid
      } else {
        let normalizedArtistid = artistid
        if (!endsWith(artistid, 'a')) {
          normalizedArtistid = normalizedArtistid + 'a'
        }
        if (artistid.length < 7) {
          normalizedArtistid = padStart(normalizedArtistid, 7, '0')
        }
        return normalizedArtistid
      }
    },
    getArtist () {
      this.loading = true
      const artistid = this.getNormalizedArtistid(this.$route.params.artistid)
      DataService.getArtistByArtistId(artistid)
        .then(
          /** @param {ArtistidDiscography} artistidDiscrographyResult */
          (artistidDiscrographyResult) => {
            this.mainArtist = artistidDiscrographyResult.artistid
            this.alsoknownas = artistidDiscrographyResult.alsoknownas
            this.recordingswith = artistidDiscrographyResult.recordingswith
            this.discography = artistidDiscrographyResult.discography
            this.loading = false
          })
        .then(() => {
          // reset pagination
          this.$nextTick(() => {
            if (this.$refs.paginator) {
              this.$refs.paginator.goToPage(1)
            }
          })
        })
        .catch((e) => {
          logger.error('Could not get discography by artistid:' + e)
          this.loading = true
          this.$router.replace('/404')
        })
    },
    onPageChange () {
      $('html,body').stop().animate({ scrollTop: $('#discography-container').offset().top }, 600)
    }
  },
  created () {
    this.getArtist()
  }
}
</script>

<style scoped>

</style>
